const ShopIcon = ({ className }: { className?: string }) => (
    <svg className={className} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1695_1468)">
<path d="M34.9752 15H13C12.4477 15 12 15.4477 12 16V38C12 38.5523 12.4477 39 13 39H34.9752C35.5275 39 35.9752 38.5523 35.9752 38V16C35.9752 15.4477 35.5275 15 34.9752 15Z" stroke="currentColor" stroke-width="2"/>
<path d="M30.9273 15C28.0051 7.68486 19.2385 9.01489 17.0469 15" stroke="currentColor" stroke-width="2"/>
<path d="M17.0312 17.9889C20.004 25.3539 28.7443 23.9706 30.8861 17.9229" stroke="currentColor" stroke-width="2"/>
</g>
<defs>
<clipPath id="clip0_1695_1468">
<rect width="26" height="31" fill="white" transform="translate(11 9)"/>
</clipPath>
</defs>
</svg>

);

export default ShopIcon;
